import { tv } from "tailwind-variants";
const selectionInputVariants = tv({
  slots: {
    groupRoot: "flex flex-wrap",
    item: `
flex whitespace-nowrap rounded-md items-center justify-center text-center gap-3 p-4 text-slate-900
transition-all focus-visible:outline-none ring-1 ring-slate-300 
data-[state=on]:ring-blue-600 data-[state=on]:bg-blue-100 
lg:hover:ring-blue-600 lg:hover:bg-white 
disabled:bg-slate-100 disabled:text-slate-400 disabled:cursor-not-allowed disabled:hover:ring-slate-300 disabled:data-[state=on]:ring-slate-300 disabled:data-[state=on]:bg-slate-100`
  },
  variants: {
    size: {
      default: {
        item: "min-h-5xl text-s2",
        groupRoot: "gap-3"
      },
      lg: {
        item: "text-s1 min-h-[3.875rem]",
        groupRoot: "gap-4"
      }
    },
    direction: {
      horizontal: { groupRoot: "" },
      vertical: { groupRoot: "flex-col" }
    },
    isInvalid: {
      true: {
        item: "ring-red data-[state=on]:ring-red-600 data-[state=on]:bg-red-100 hover:ring-red-600 hover:bg-white"
      }
    }
  },
  compoundVariants: [
    { size: "lg", direction: "horizontal", className: "justify-start" },
    { size: "lg", direction: "vertical", className: "justify-center" }
  ],
  defaultVariants: {
    size: "default",
    variant: "default",
    direction: "horizontal"
  }
});
export {
  selectionInputVariants
};
